import _ = require("lodash");
import { defaultAssetClassNames } from "@models/portfolioadmin/PortfolioAttributionBenchmarkDto ";

export const getWaterfallOptions = (labels: string[], values: BarChartStyleOption[]) => {
    let total = Math.round((_.sumBy(values, item => item.value) + Number.EPSILON) * 100) / 100
    let performance = [new BarChartStyleOption(total, '#097896')]
    let offsetValues = [0]

    const columnLabels = labels
    .map((x) => {
      let label = x;
      let assetClassName = defaultAssetClassNames.find((n) => n.longName == x);

      if (!!assetClassName) {
        label = assetClassName.shortName;
      }

      if (x === "Cash") {
        label = "CASH";
      }
      if (x === "Alternative Inv") {
        label = "ALT INVT";
      }
      if (x === "Commodities") {
        label = "COMMODITIES";
      }

      return label;
    })
    .reverse();

    columnLabels.push('Total')
    
    for(let item of values) {
        if(item.value < 0) {
            performance.push({
                ...item,
                value: (-1 * item.value)
            })
            offsetValues.push(total)
        } else {
            performance.push(item)
            total -= item.value;
            offsetValues.push(total)
        }
    }

    return {
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            axisLine: {
                show: false
              },
            axisTick: {
            show: false
            },
            min: 'dataMin',
            data: columnLabels 
        },
        yAxis: {
            axisLine: {
                show: false
            },
            axisTick: {
            show: false
            },
            type: 'value',
            min: 'dataMin',
        },
        series: [
            {
                name: 'Placeholder',
                type: 'bar',
                stack: 'Total',
                silent: true,
                itemStyle: {
                    borderColor: 'transparent',
                    color: 'transparent'
                },
                emphasis: {
                itemStyle: {
                    borderColor: 'transparent',
                    color: 'transparent'
                }
                },
                data: offsetValues.reverse()
            },
            {
                name: 'Performances',
                type: 'bar',
                stack: 'Total',
                label: {
                    show: true,
                    position: 'top'
                },
                data: performance.reverse()
            }
        ]
    }
  };

  export class BarChartStyleOption {
    value: number
    itemStyle: ChartStyle

    constructor(value: number, color: string) {
        this.value = value
        this.itemStyle = new ChartStyle(color)
    }
  }

  export class ChartStyle {
    color: string
    constructor(color: string) {
        this.color = color
    }
  }

  export const formatLongNames = (name: string) => {
    let wrappedName = ''
    wrappedName = name.split(" ")[0]
    wrappedName += '\n'
    wrappedName = name.split(" ")[1]
    return wrappedName
  }
     


// WEBPACK FOOTER //
// ./src/app/common/waterfall-chart-options.ts